import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, filter, tap } from 'rxjs/operators';
import { UserService } from '../services'

@Component({
    selector: 'app-nav',
    styles: [`
        .mat-tab-label-active {
            opacity: 1;
        }
    `],
    template: `
        <nav class="appNav" mat-tab-nav-bar style="border-bottom: none;">
            <a *ngIf="digestHome && !userIsCatalogManager"
               mat-tab-link 
               [routerLink]="['/browse/home']" 
               [active]="homeActive" 
               style="min-width: 90px; color: white;">
            <mat-icon aria-label="My Briefing">list_alt</mat-icon> My Briefing
            </a>
            <a *ngIf="!digestHome && !userIsCatalogManager"
                mat-tab-link 
               [routerLink]="['/digest']" 
               [active]="homeActive" 
               style="min-width: 90px; color: white;">
            <mat-icon aria-label="My Briefing">list_alt</mat-icon> My Briefing
            </a>
            <a *ngIf="!userIsCatalogManager"
               mat-tab-link
               [routerLink]="['/browse']" 
               [active]="discoverActive" 
               style="min-width: 90px; color: white;">
                <mat-icon aria-label="Discover">local_library</mat-icon> Discover Topics
            </a>
        </nav>
    `
})
export class AppNavigationComponent implements OnInit, OnDestroy {
    @Input() digestHome = false;
    private cleanupTime = new Subject<void>();
    homeActive: boolean;
    discoverActive: boolean;
    userIsCatalogManager: boolean;

    constructor(private router: Router, private userService:UserService) {}
    
    ngOnInit(): void {
        const homeLink = this.digestHome ? '/browse/home' : '/digest';
        this.homeActive = this.router.url.startsWith(homeLink);
        this.discoverActive = this.router.url.startsWith('/browse');
        this.userIsCatalogManager = this.userService.isCurrentUserCatalogManager();
        this.router.events
        .pipe(
            filter(event => event instanceof NavigationEnd),
            tap((event: NavigationEnd) => this.homeActive = event.url.startsWith(homeLink)),
            tap((event: NavigationEnd) => this.discoverActive = event.url.startsWith('/browse')),
            takeUntil(this.cleanupTime)
        )
        .subscribe();
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
